<template>
    <div class="">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Pallet Sizes</li>
            </ol>
            <h4 class="main-title mb-2">Pallet Sizes</h4>
        </div>
        <div class="row">
            <div class="col-4" v-can="'pallet_sizes.create'">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Pallet Size</h6>
                            <h6 class="card-title" v-else>Update Pallet Size</h6>
                        </div>
                        <div class="card-body ">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <label class="form-label">Pallet Size Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Pallet Size Code" class="form-control" :class="{ 'is-invalid': errors.pallet_size_code }" v-model="pallet_size.pallet_size_code" ref="pallet_size_code" />
                                    <span v-if="errors.pallet_size_code"><small class="text-danger">{{ errors.pallet_size_code[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Pallet Size Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Pallet Size Name" class="form-control" :class="{ 'is-invalid': errors.pallet_size_name }" v-model="pallet_size.pallet_size_name" />
                                    <span v-if="errors.pallet_size_name"><small class="text-danger">{{ errors.pallet_size_name[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button type="submit" class="btn btn-primary" >
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div :class="column">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Pallet Sizes</h6>
                    </div>
                    <div class="card-body ">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-striped table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('pallet_size_code')">Pallet Size Code
                                            <span>
                                                <i v-if="meta.keyword=='pallet_size_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='pallet_size_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                        <th @click="sort('pallet_size_name')">Pallet Size Name
                                        
                                            <span>
                                                <i v-if="meta.keyword=='pallet_size_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='pallet_size_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>

                                        <th class="text-center" v-can="'pallet_sizes.delete'">Status</th>
                                        <th class="text-center" v-can="'pallet_sizes.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="pallet_sizes.length==0">
                                        <td colspan="5" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="pallet_size, key in pallet_sizes" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{pallet_size.pallet_size_code}}</td>
                                        <td>{{ pallet_size.pallet_size_name }}</td>
                                        <td class="text-center" v-can="'pallet_sizes.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'pallet_size' + pallet_size.pallet_size_id" :checked="pallet_size.status" :value="pallet_size.status" @change="deletePalletSize(pallet_size)" />
                                                <label class="custom-control-label" :for="'pallet_size' + pallet_size.pallet_size_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'pallet_sizes.update'">
                                            <a href="javascript:void(0)" v-if="pallet_size.status" class="text-success me-2" @click="editPalletSize(pallet_size)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                column:'',
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "pallet_size_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                pallet_size: {
                    pallet_size_id: "",
                    pallet_size_code: "",
                    pallet_size_name: "",
                },
                status: true,
                pallet_sizes: [],
                errors: [],
            };
        },
        mounted() {
            this.create_palletsize = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('pallet_sizes.create')
            })
            if(this.create_palletsize.length){
                this.column = 'col-8'
            }else{
                this.column = 'col-12'
            }
            this.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addPalletSize();
                } else {
                    vm.updatePalletSize();
                }
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginatePalletSizes", data: vm.meta })
                    .then((response) => {
                        vm.pallet_sizes = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addPalletSize() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addPalletSize", data: vm.pallet_size })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Pallet Size Added successfully");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updatePalletSize() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updatePalletSize", data: vm.pallet_size })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Pallet Size is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editPalletSize(pallet_size) {
                let vm = this;
                vm.$refs.pallet_size_code.focus();
                vm.errors = [];
                vm.status = false;
                vm.pallet_size = pallet_size;
            },

            deletePalletSize(pallet_size) {
                let vm = this;
                let loader = vm.$loading.show();
                pallet_size.status = pallet_size.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deletePalletSize", data: pallet_size })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            discard() {
                let vm = this;
                vm.pallet_size.pallet_size_code = "";
                vm.pallet_size.pallet_size_name = "";
                vm.$refs.pallet_size_code.focus();
                vm.errors = [];
                vm.status = true;
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            
        },
    };
</script>
